import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import './app/theme.css';
import { createQueryClient } from './app/queryClient';
import { ToastProvider } from './components/ui/Toast';
import { AuthProvider } from './features/auth/AuthProvider';
import { applyTheme } from './hooks/useTheme';
import { routes } from './routes/routes';
import { readPreference } from './utils/storage';

// Apply the stored theme before the first paint to avoid a light flash in dark mode.
const storedTheme = readPreference('theme');
applyTheme(storedTheme === 'light' || storedTheme === 'dark' ? storedTheme : 'system');

const router = createBrowserRouter(routes);
const queryClient = createQueryClient();

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
